"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var component_button_1 = __importDefault(require("@doordash/component-button"));
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var App_1 = require("../../App");
var i18n_1 = require("../../i18n/i18n");
var ImpressionTracker_1 = __importDefault(require("../Tracking/ImpressionTracker"));
var TwoFactorAuthenticationStrings_1 = __importDefault(require("../TwoFactorAuthenticationStrings"));
var TwoFactorAuthenticationUtils_1 = require("../TwoFactorAuthenticationUtils");
// tslint:disable-next-line:max-line-length
var VerifyAccountContext_1 = __importDefault(require("../VerifyAccountContext"));
var VerifyAccountStyles_1 = require("../VerifyAccountStyles");
var VerifyAccountTracking_1 = require("../VerifyAccountTracking");
var VerifyPasscode_1 = __importDefault(require("../VerifyPasscode"));
var BlockedUserTracking_1 = __importDefault(require("./BlockedUserTracking"));
var TwoFactorModalContent = function () {
    var _a = React.useContext(App_1.RiskContext), experience = _a.experience, state = _a.state;
    var accountBlocked = React.useContext(VerifyAccountContext_1["default"]).accountBlocked;
    var experienceStrings = i18n_1.getStringsForExperience(TwoFactorAuthenticationStrings_1["default"], experience);
    return (React.createElement(VerifyAccountStyles_1.Root, null,
        React.createElement(VerifyAccountStyles_1.VerifyAccountContainer, null,
            React.createElement(design_language_1.StackChildren, null, accountBlocked ? (React.createElement(BlockedUserTracking_1["default"], null, function (trackHelpClick) { return (React.createElement(design_language_1.StackChildren, null,
                React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.PageSubtext, textAlign: design_language_1.Text.TextAlignments.Center }, // tslint:disable-next-line:max-line-length
                TwoFactorAuthenticationStrings_1["default"].tooManyAttemptsExplanation()),
                React.createElement(component_button_1["default"], { tag: "a", href: TwoFactorAuthenticationUtils_1.HELP_LINK, onClick: trackHelpClick }, TwoFactorAuthenticationStrings_1["default"].contactSupport()))); })) : (React.createElement(ImpressionTracker_1["default"], { onImpression: function () { return VerifyAccountTracking_1.trackChallengeTrigger(state.workflow); } },
                React.createElement(VerifyPasscode_1["default"], { primaryText: experienceStrings.forSecurityIsYou() })))))));
};
exports["default"] = TwoFactorModalContent;
